import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { generateDateTicks } from "../../../services/dataTicks";

const FuelParameterChart = ({ emissionFuelParams }) => {
  console.log("emissionFuelParams", emissionFuelParams);
  const selectedParam = "Total MT/Day";

  const fleetData = useMemo(() => {
    if (
      emissionFuelParams &&
      emissionFuelParams.dates &&
      emissionFuelParams.dates.length > 0 &&
      emissionFuelParams.parameters
    ) {
      return emissionFuelParams;
    }
    return null;
  }, [emissionFuelParams]);

  // Check if all values are zero - moved before conditional return
  const allValuesZero = useMemo(() => {
    if (!fleetData || !fleetData.parameters[selectedParam]?.average) return false;
    const averages = fleetData.parameters[selectedParam].average;
    return averages.length > 0 && averages.every(val => val === 0);
  }, [fleetData, selectedParam]);

  // Add safety check for fleetData - moved after all hooks
  if (!fleetData) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">No fuel parameter data available</div>
      </div>
    );
  }

  let tickPositions = generateDateTicks(fleetData.dates);

  const safeValue = (val, maxThreshold = 10000) => {
    const num = Number(val);
    return isFinite(num) && Math.abs(num) < maxThreshold ? num : 0;
  };

  const seriesData = [
    {
      name: "Total MT/Day",
      type: "line",
      data: fleetData.dates.map((date, i) => ({
        x: new Date(date).getTime(),
        y: safeValue(fleetData.parameters[selectedParam]?.average[i]),
        min: safeValue(fleetData.parameters[selectedParam]?.min[i]),
        max: safeValue(fleetData.parameters[selectedParam]?.max[i]),
      })),
      color: "#1a5276",
      lineWidth: 3,
      marker: { 
        symbol: "circle", 
        radius: 5, 
        lineWidth: 1, 
        lineColor: "#fff",
        enabled: true
      },
    }
  ];

  const chartOptions = {
    chart: {
      type: "line",
      zoomType: "xy",
      backgroundColor: "transparent",
      height: 400,
    },
    title: {
      text: null,
    },
    xAxis: {
      type: "datetime",
      tickPositions: tickPositions,
      title: { text: "Date" },
      labels: { format: "{value:%b %e}" },
      gridLineWidth: 1,
    },
    yAxis: {
      title: {
        text: "Total MT/Day",
        style: {
          fontWeight: 'bold'
        }
      },
      min: 0,
      minPadding: 0,
      maxPadding: 0.05,
      tickAmount: 6,
      gridLineWidth: 1,
      startOnTick: true,
      endOnTick: true,
    },
    tooltip: {
      useHTML: true,
      shared: true,
      headerFormat: "<b>{point.key:%b %e}</b><br>",
      pointFormat: `
        <span style="color:{point.color}">●</span> 
        {series.name}: <b>{point.y}</b> MT<br/>
      `,
    },
    legend: {
      enabled: true,
      align: 'center',
      verticalAlign: 'top',
      layout: 'horizontal'
    },
    series: seriesData,
    credits: { enabled: false },
    plotOptions: {
      series: {
        states: {
          hover: {
            halo: {
              size: 5,
              opacity: 0.25,
            },
          },
          inactive: {
            opacity: 1
          }
        },
      },
      line: {
        cursor: 'pointer',
        point: {
          events: {
            mouseOver: function() {
              this.series.chart.tooltip.refresh(this);
            }
          }
        },
        minPointLength: 1,
      }
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default FuelParameterChart;